import { computed } from "vue";

export function useChartPreview(props) {
  const chartWidth = computed(() => props.width - props.padding * 2);
  const chartHeight = computed(() => props.height - props.padding * 2);
  const displayColors = computed(() => props.colors);

  // Generate pseudo-random but consistent values based on indices
  function getValue(catIdx, seriesIdx) {
    const seed = (catIdx * 7 + seriesIdx * 13) % 10;
    return 0.4 + (seed / 10) * 0.5; // Values between 0.4 and 0.9
  }

  return { chartWidth, chartHeight, displayColors, getValue };
}
